// releaseInfo.js
const tagName = process.env.TAG_NAME;
const branchName = process.env.BRANCH_NAME;
const shortSha = process.env.SHORT_SHA;

/**
 * The release tag Sentry uses to label errors, e.g. `v3.286.4+abc12345`.
 *
 * Why a separate file: the SW imports sentry.js. If sentry.js read these
 * process.env values directly, the SW would reinstall on every deploy. So
 * the reads live here — a file the SW doesn't import — and the main app
 * passes `release` into sentry.js via setSentryRelease().
 */
const release = `${tagName || branchName?.replace(/[^a-z\d]/gi, '-')}+${shortSha}`;

export { release };
